import React from "react";
import { Link } from "react-router-dom";

import {
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { DateField, NumberField, SelectField } from "react-admin";

import { LowInventoryIcon } from "../../../components/common/LowInventoryIcon";
import { PhotoViewer } from "../../../components/common/PhotoViewer";

import { InventoryStatus, InventoryStatuses } from "../../../utils/constants";

import { InventoryStatusIcon } from "../../../managerApp/resources/inventory/InventoryStatusIcon";

const useAsideStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("sm")]: {
      width: "18em",
      minWidth: "18em",
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(0.5),
      overflow: "initial",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  // centerAlign: {
  //   textAlign: "center",
  // },
  status: {
    marginTop: theme.spacing(0.3),
  },
}));

export const InventoryAside = ({ backPath, record, ...props }) => {
  const classes = useAsideStyles();
  const linkBackPath = backPath
    ? [...backPath, props.location.pathname]
    : [props.location.pathname];

  if (!record) return null;
  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container direction="column" spacing={1}>
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Status:
            </Typography>
            <Grid container direction="row">
              <Grid item xs={2}>
                <InventoryStatusIcon inventory={record} />
              </Grid>
              <Grid item xs={10} className={classes.status}>
                <SelectField
                  source="status"
                  record={record}
                  choices={InventoryStatuses}
                />
              </Grid>
            </Grid>
            {record.status === InventoryStatus.STORED &&
              record.product?.lowInventoryAlert && (
                <Grid container direction="row">
                  <Grid item xs={2}>
                    <LowInventoryIcon record={record} />
                  </Grid>
                  <Grid item xs={10} className={classes.status}>
                    Low Inventory
                  </Grid>
                </Grid>
              )}
          </Grid>
          {record.receivedAt && (
            <Grid item xs={12}>
              <Typography variant="overline" color="textSecondary">
                Date Received:
              </Typography>
              <br />
              <DateField source="receivedAt" record={record} />
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Inbound Shipment:
            </Typography>
            <br />
            <Link
              to={{
                pathname: `/inboundShipments/${record.inboundShipmentId}/show`,
                state: { backPath: linkBackPath },
              }}
            >
              <Typography variant="body2" color="primary">
                PO no. {record.poNumber}
              </Typography>
            </Link>
            {record.status === InventoryStatus.STORED ||
            record.status === InventoryStatus.SHIPPED ? (
              <Table size="small" padding="none">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Typography variant="caption">Qty. Advised</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption">Qty. Received</Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <NumberField source="quantityAdvised" record={record} />
                    </TableCell>
                    <TableCell>
                      <NumberField source="quantityReceived" record={record} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            ) : null}
          </Grid>
          {record.shipmentLineItems?.items &&
            record.shipmentLineItems.items.length > 0 && (
              <Grid item xs={12}>
                <Typography variant="overline" color="textSecondary">
                  Outbound Shipments:
                </Typography>
                <br />
                <Table size="small" padding="none">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Typography variant="caption">Quantity</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="caption">PO No.</Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {record.shipmentLineItems.items.map((itm) => (
                      <TableRow>
                        <TableCell>
                          <NumberField
                            source="totalQuantityToPick"
                            record={itm}
                          />
                        </TableCell>
                        <TableCell>
                          <Link
                            to={{
                              pathname: `/outboundShipments/${itm.outboundShipmentId}/show`,
                              state: { backPath: linkBackPath },
                            }}
                          >
                            <Typography variant="body2" color="primary">
                              {itm.poNumber}
                            </Typography>
                          </Link>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Grid>
            )}
          {/* <Grid item xs={12} className={classes.centerAlign} >
                <Link to={`/search/timeline/${record.id}`} >
                    <Button label="View Timeline" color="default" >
                        <TimelineIcon fontSize="small" />
                    </Button>
                </Link>
            </Grid> */}
          <PhotoViewer photos={record.photos?.items} />
        </Grid>
      </CardContent>
    </Card>
  );
};
